"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dayjsToProtobufTimestamp = exports.protobufTimestampToDayjs = void 0;
const timestamp_pb_1 = require("google-protobuf/google/protobuf/timestamp_pb");
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
/**
 * Converts a Protobuf Timestamp to a Day.js object.
 *
 * @param {Timestamp} protobufTimestamp - The Protobuf Timestamp object to be converted.
 * @returns {dayjs.Dayjs} A Day.js object representing the same point in time.
 *
 * @example
 * const protobufTimestamp = new Timestamp();
 * protobufTimestamp.setSeconds(1692144000);
 * protobufTimestamp.setNanos(0);
 * const dayjsDate = protobufTimestampToDayjs(protobufTimestamp);
 * console.log(dayjsDate.toString());
 */
function protobufTimestampToDayjs(protobufTimestamp) {
    return dayjs_1.default.utc(Math.floor(protobufTimestamp.getSeconds() * 1e3 + protobufTimestamp.getNanos() / 1e6));
}
exports.protobufTimestampToDayjs = protobufTimestampToDayjs;
/**
 * Converts a Day.js object to a Protobuf Timestamp.
 *
 * @param {dayjs.Dayjs} dayjsDate - A Day.js object representing a point in time.
 * @returns {Timestamp} A Protobuf Timestamp object representing the same point in time.
 *
 * @example
 * const dayjsDate = dayjs.utc('2023-01-01');
 * const protobufTimestamp = dayjsToProtobufTimestamp(dayjsDate);
 * console.log(protobufTimestamp.toObject());
 */
function dayjsToProtobufTimestamp(dayjsDate) {
    const timestamp = dayjsDate.utc().unix();
    const nanos = Math.floor(dayjsDate.millisecond() * 1e6); // Convert milliseconds to nanoseconds
    const protobufTimestamp = new timestamp_pb_1.Timestamp();
    protobufTimestamp.setSeconds(timestamp);
    protobufTimestamp.setNanos(nanos);
    return protobufTimestamp;
}
exports.dayjsToProtobufTimestamp = dayjsToProtobufTimestamp;
